import { DEFAULT_RANGE_TOKEN, resolveRangeToken } from "../service/dateRange";
import { Key, OverviewKey } from "./enums";
import { displayStateMetadata, lastLearnedMetadata } from "./config/support";
import { BiteDisplayState } from "../types/enums";
import { AppliedFilters, GOAL_BUCKETS } from "./config/filter";
import { SORT_PRESETS, type SortPreset } from "./config/sort";

export const keys = [
  Key.STUDENT_NAME,
  Key.LESSON_NAME,
  Key.BITES,
  Key.GOALS,
  Key.PRE_ASSESSMENT,
  Key.EXIT_TICKET,
  Key.CUSTOM_TICKET,
  Key.TIME_SPENT,
  Key.CLASSROOM_NAME,
  Key.ASSIGN_DATE,
  Key.LESSON_STATUS,
];

export const overviewKeys: OverviewKey[] = [
  OverviewKey.TOTAL_STUDENTS,
  OverviewKey.LESSONS_STARTED,
  OverviewKey.LESSONS_COMPLETED,
  OverviewKey.AVERAGE_TIME_SPENT,
  OverviewKey.COMPLETION_RATE,
];

export const supportKeys = [
  displayStateMetadata[BiteDisplayState.FLAWLESS],
  displayStateMetadata[BiteDisplayState.LOW],
  displayStateMetadata[BiteDisplayState.MEDIUM],
  displayStateMetadata[BiteDisplayState.HIGH],
  displayStateMetadata[BiteDisplayState.INCOMPLETE],
  displayStateMetadata[BiteDisplayState.NOT_STARTED],
  displayStateMetadata[BiteDisplayState.PROCESSING],
  lastLearnedMetadata,
];

export const defaultFilterValues: AppliedFilters = {
  [Key.STUDENT_NAME]: [],
  [Key.CLASSROOM_NAME]: [],
  [Key.LESSON_NAME]: [],
  [Key.LAST_LEARNED]: resolveRangeToken(DEFAULT_RANGE_TOKEN)!,
  includeNotStarted: true,
  [Key.TIME_SPENT]: [],
  [Key.GOALS]: GOAL_BUCKETS.filter((bucket) => bucket !== "0%"),
};

export const doNotTruncateKeys: Key[] = [Key.BITES];

export const defaultSortPreset: SortPreset = SORT_PRESETS[Key.STUDENT_NAME]![0];
